/**
 * Writes backend-computed closing-cost rows (see closingCostOverrideService.resolveOverrides,
 * POST /buyer-title-escrow-costs) into closingCostsMeta at the literal array index the backend
 * sends (`sr_no`) — the same direct-index pattern as applyWaSalesTaxClosingCosts. Each override
 * replaces whatever row (if any) currently sits at that position; nothing is merged/preserved
 * from it, same as the WA sales-tax rows. All matching/state decisions already happened on the
 * backend — this is a dumb writer, nothing more.
 *
 * A future override (any state, any fee) only needs backend changes — nothing here has to grow.
 *
 * @param {Object} prev - formData (or a draft of it) with a closingCostsMeta array
 * @param {Array<{sr_no:number, [field:string]:any}>} overrides - finished rows
 */
export function applyClosingCostOverrides(prev, overrides) {
  if (!Array.isArray(overrides) || overrides.length === 0) return prev;

  const source = prev?.closingCostsMeta;
  const closingCostsMeta = Array.isArray(source) ? [...source] : [];

  for (const row of overrides) {
    if (row?.sr_no == null) continue;
    closingCostsMeta[row.sr_no] = row;
  }

  return {
    ...prev,
    closingCostsMeta,
  };
}
